module.exports = __webpack_public_path__ + "static/employee_soj-2cb29a4a41ed300df77e0ef4073cd64d.jpg";